var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu",attrs:{"id":"app"}},[_c('h1',[_vm._v("Projects")]),_c('div',{staticClass:"projects-container"},_vm._l((_vm.projects),function(project){return _c('ProjectCard',{key:project.slug,attrs:{"project":project}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }